// src/data/projects/list.js
const projectSlugs = [
  "budget-or-hard-problem",
  "implementing-design-intent-in-baseboard",
  "detail_drawing",
  "design-tool-implementation",
  "thesis",
  "jungle",
];

export default projectSlugs;
